export const MARITAL_STATUS_OPTIONS = [
  { value: "single", description: "Single" },
  { value: "married", description: "Married" },
  { value: "divorced", description: "Divorced" },
  { value: "widowed", description: "Widowed" },
  { value: "separated", description: "Separated" },
  { value: "civil_partnership", description: "In a civil partnership" },
] as const;

export const SEX_OPTIONS = [
  { value: "male", description: "Male" },
  { value: "female", description: "Female" },
] as const;

export const WORK_PERMIT_OPTIONS = [
  { value: "has_permit", description: "Yes – Has a valid permit" },
  { value: "requires_permit", description: "Yes – Requires a permit" },
  { value: "not_required", description: "No – Not required" },
] as const;
